import React from 'react';

import dayjs from "dayjs";

import {CircularProgress, Stack} from "@mui/joy";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import BaseApi from "../../utils/BaseApi";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import TaskDetail from "../Task/TaskDetail";

// icons


class SliceTaskAdd extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            tasks: null,
        };
    }

    async componentDidMount() {
        await this.retrieveTasks();
    }

    async retrieveTasks(){
        const api = new BaseApi();
        let url = `slice/${this.props.slice.id}/available_tasks/`;
        let response = await api.get(url, {});
        this.setState(
            {
                tasks: response.data,
            }
        );
    }

    async addTasks(selected){
        const api = new BaseApi();
        let url = `slice/${this.props.slice.id}/add_tasks/`;
        let response = await api.post(
            url,
            {
                tasks: selected
            }
        );
        if (response.status === 200) {
            await this.props.callBack();
        }
    }

    render() {
        if (!this.state.tasks) {
            return (<CircularProgress/>)
        }
        return(
            <Stack>
                <CommonPaginatedTable
                    title={null}
                    data={this.state.tasks}
                    selection={{
                        buttons: [
                            {
                                callBack: this.addTasks.bind(this),
                                label: 'Добавить',
                                icon: null,
                                color: 'success',
                                variant: 'solid',
                                position: 'bottom',
                            },
                        ]
                    }}
                    fields={[
                        {
                            title: 'Название',
                            name: 'title',
                            visible: true,
                        },
                        {
                            title: 'План',
                            name: 'duration_plan',
                            chip: true,
                            color_rule: (value, comparison) => ('primary'),
                            visible: true,
                        },
                        {
                            title: 'Факт',
                            name: 'duration_plan',
                            chip: true,
                            color_rule: (value, comparison) => ('primary'),
                            visible: true,
                        },
                        {
                            title: 'Дата начала',
                            name: 'start_dt',
                            visible: true,
                            preProcess: (value) => (value?dayjs(value).format('DD MMM YYYY'):value)
                        },
                        {
                            title: 'Дата окончания',
                            name: 'end_dt',
                            visible: true,
                            preProcess: (value) => (value?dayjs(value).format('DD MMM YYYY'):value)
                        },
                        {
                            title: 'Редактировать',
                            visible: true,
                            component: TaskDetail,
                            componentProps: {
                            },
                            callBack: this.retrieveTasks.bind(this),
                            width: '50px',
                        },
                        // {
                        //     title: 'Автор',
                        //     component: ProfileHorizontalByProps,
                        //     componentProps: {
                        //
                        //     },
                        //     visible: true,
                        // },
                        // {
                        //     title: 'Исполнитель',
                        //     component: ProfileHorizontalByProps,
                        //     componentProps: {
                        //
                        //     },
                        //     visible: true,
                        // },
                    ]
                    }
                />
            </Stack>
        )
    }
}

export default SliceTaskAdd